import fileHttp from "@/http/requests/file"
import state from '@/store/state'
import axios from 'axios'

export const replaceAll = (string, from, to) => {
  const stringLength = string.length
  let position = 0
  while (position < stringLength) {
    string = string.replace(from, to)
    position++
  }

  return string
}

export const moneyToFloat = (money) => {
  money = money.toString().replace('R$ ', '')
  money = replaceAll(replaceAll(money, ',', ''), '.', '')

  const unitPosition = money.length - 2
  money = parseFloat([
    money.slice(0, unitPosition),
    '.',
    money.slice(unitPosition)
  ].join(''))

  return money
}

export const b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

export const formatTenantPath = (string) => {
  return string
}

export const getBaseUrl = () => {
  return process.env.VUE_APP_BASE_URL;
}

export const getCurrentTenant = () => {
  return window.location.href.replace(process.env.VUE_APP_BASE_URL, '').split('/')[0];
}

export const formatRouteTenantPath = (route) => {
  return route;
}

export const isOriginalBackoffice = () => {
  return window.location.href.includes('backoffice.pedbot')
}

export const encodeToBase64 = content => {
  return btoa(unescape(encodeURIComponent(content)))
}

export const decodeFromBase64 = content => {
  return decodeURIComponent(escape(atob(content)))
}

export const parseItemFromObjectToString = (index, item, isLastItem) => {
  if (typeof item === 'object') {
      item = index + ` { ` + parseObjectToString(item) + ` }`;
  }

  return item + (isLastItem ? '' : ', ');
}

export const removeFileFromBucket = (fileUrl) => {
  const urlArray = fileUrl.split("/");
  const filename = urlArray[urlArray.length - 1]

  const headers = {
    Authorization: 'Bearer ' + state.auth.bearer
  }

  return fileHttp
    .delete(filename, headers)
    .catch(err => {
      console.error(err)
    })
}

export const parseObjectToString = (object) => {
  let objectString = ''

  const objectIndexes = Object.keys(object)
  const objectValues = Object.values(object)

  for (const [index, item] of Object.entries(object)) {
    objectString += parseItemFromObjectToString(
      index,
      item,
      (
        objectIndexes[objectIndexes.length - 1] === index &&
        objectIndexes[objectValues.length - 1] === item
      )
    )
  }

  return objectString
}

export const parseParamToString = (item, value) => {
  if (typeof value === 'string') {
      return item + `: "` + value + `", `;
  }

  return item + `: ` + value + ', ';
}

export const parseObjectParamsToString = (params) => {
  if (Object.keys(params).length === 0) {
      return '';
  }

  let objectString = '';

  for (const [index, item] of Object.entries(params)) {
    objectString += parseParamToString(index, item);
  }

  return ` ( ` + objectString + ` )`;
}

export const formatGraphqlBody = (type, functionName, responseItems, params = {}) => {
  const responseItemsString = parseObjectToString(responseItems)
  const paramsItemsString = parseObjectParamsToString(params)

  return { query:  type + " { " + functionName + paramsItemsString + " { " + responseItemsString + " } } " }
}

export const formatGraphqlParams = (params) => {
  const formatedParams = {}
  for (const [index, item] of Object.entries(params)) {
    if (item !== '' && item !== null && item !== undefined) {
      formatedParams[index] = item
    }
  }

  return formatedParams
}

export const formatDate = (date) => {
  if (date === null || date === '') {
    return {
      day: '',
      month: '',
      year: '',
      hour: '',
      minute: '',
      second: '',
      full: '',
      date_only: ''
    };
  }

  const d = new Date(date);

  let day = d.getDate();
  let month = d.getMonth() + 1;
  const year = d.getFullYear();
  let hour = d.getHours();
  let minute = d.getMinutes();
  let second = d.getSeconds();

  if (day < 10) { day = `0${day}`; }
  if (month < 10) { month = `0${month}`; }
  if (hour < 10) { hour = `0${hour}`; }
  if (minute < 10) { minute = `0${minute}`; }
  if (second < 10) { second = `0${second}`; }

  return {
    day,
    month,
    year,
    hour,
    minute,
    second,
    full: `${day}/${month}/${year} ${hour}:${minute}:${second}`,
    date_only: `${day}/${month}/${year}`
  }
}

export const parsePhoneNumber = (phoneNumber) => {
  const parsedNumber = phoneNumber.toString().replace(/[^0-9.]+/gi, '')
  const hasCountryCode = parsedNumber.substr(0, 2) === "55"
  return hasCountryCode
    ? (parsedNumber.length <= 11 ? `55${parsedNumber}` : parsedNumber)
    : `55${parsedNumber}`
}

export const maskPhoneNumberToBrazilian = (phoneNumber) => {
  /**
   * If the phone number is in the old format: (XX) XXXXX-XXXX,
   * it'll be replaced to 55XXXXXXXXXXX
   */
  phoneNumber = parsePhoneNumber(phoneNumber);

  const phoneLength = phoneNumber.length;
  const ddd = phoneNumber.substr(2, 2);
  const prefix = phoneNumber.substr(4, phoneLength === 12 ? 4 : 5);
  const suffix = phoneNumber.substr(phoneLength - 4, 4);

  return `(${ddd}) ${prefix}-${suffix}`;
}

export const getChatOptionAsTreeChild = (chatOption, useNode = false, allExpanded = false) => {        
  if (useNode) {
    return {
      title: chatOption.title,
      is_close: chatOption.is_close,
      expanded: allExpanded,
      type: chatOption.type,
      children: chatOption.children
      ?
      chatOption.children.map(
        option => getChatOptionAsTreeChild(option, true, true)
      )
      :
      []
    }
  }
  
  return {
    title: `${chatOption.id}|${chatOption.number}|${chatOption.number ? chatOption.number + ' - ' : ''}`
      + `${chatOption.description}`,
    expanded: false,
    is_close: chatOption.is_close,
    type: chatOption.type,
    children: chatOption.childOptions
    ?
    chatOption.childOptions.map(
      option => getChatOptionAsTreeChild(option)
    )
    :
    []
  }
}

export const getOptionDataFromNodeTitle = (nodeTitle, parent) => {
  const optionId = parseInt(nodeTitle.substr(0, nodeTitle.indexOf('|')));
  nodeTitle = nodeTitle.replace(`${optionId}|`, '')

  let optionNumber = nodeTitle.substr(0, nodeTitle.indexOf('|'));
  nodeTitle = nodeTitle.replace(`${optionNumber}|`, '')
  optionNumber = parseInt(optionNumber)

  let parentId;

  if (parent) {
    const parentTitle = parent.title
    parentId = parseInt(parentTitle.substr(0, parentTitle.indexOf('|')));
  }

  return {
    optionId,
    optionNumber,
    parentId,
    newNodeTitle: nodeTitle
  }
}

export const hasPermission = (permissionName) => {
  const permissions = !state.global.permissionRoutes.length ? JSON.parse(localStorage.getItem('permissionRoutes')) : state.global.permissionRoutes;
  if (permissions) {
    return permissions.indexOf(permissionName) !== -1;
  }

  return false
}

export const lowerCaseFirstLetter = (string) => {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export const delay = async (ms) => {
    return new Promise(resolve => setTimeout(() => resolve(), ms));
};

export const hasPermissionBackOffice = (permissionName) => {
  let permissions = state.permission.permissions;

  if (permissions.length === 0) {
    permissions = JSON.parse(localStorage.getItem('permissions'));
  }

  return permissions.some(permission => {
    return permission.route_name === permissionName;
  });
}

export const availablePlans = () => {
  return [
    {
      value: 'BASIC',
      text: 'Basico'
    },
    {
      value: 'MEDIUM',
      text: 'Médio'
    },
    {
      value: 'ADVANCED',
      text: 'Avançado'
    },
    {
      value: 'EXPERT',
      text: 'Expert'
    },
    {
      value: 'ON-DEMAND',
      text: 'Sob Demanda'
    }
  ]
};

export const filterPassword = (password) => {
  const weak = 50;
  const average = 75;
  const strong = 100;

  if (/(\w)\1{2,}/.test(password)) {
    return weak;
  }
  if (/(\d)\1{2,}/.test(password)) {
    return weak;
  }
  if (/(?:012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/i.test(password)) {
    return weak;
  }
  if (password.length < 8) {
    return weak;
  }
  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(password) || !/(?=(.*?[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]){2})/.test(password)) {
    return average;
  }
  if (!/(?=.*[a-z])(?=.*[A-Z])/.test(password)) {
    return average;
  }
  return strong;
}

export const getIp = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    const ip = response.data.ip;
    return ip;
  } catch (error) {
    console.error('Erro ao obter o endereço IP:', error);
    return null;
  }
}